import { Res, DocumentType, InvoiceContentType } from 'core/api';
import { SessionProvider } from 'core/infrastructure';
import { InvoiceFacade } from 'pos/facades';
import { Message } from 'core/ui-next/modal';

export async function ensureCanReopen(document: { Id: number, ContentType: InvoiceContentType, PosId: number, PosName: string }): Promise<boolean> {

	if (!SessionProvider.getCurrent().AllowCashTransactions) {
		await Message.show(Res.Msg.MSG_CURRENT_POS_DOES_NOT_ALLOW_CASH_TRANSACTIONS());
		return false;
	}

	const hasBeenRefunded = await InvoiceFacade.hasAlreadyBeenRefunded(document.Id);
	if (hasBeenRefunded) {
		await Message.show(Res.Msg.MSG_CANNOT_REOPEN_BECAUSE_THERE_IS_ALREADY_A_REFUND());
		return false;
	}
	if (document.ContentType === InvoiceContentType.DeliveryNotes) {
		await Message.show(Res.Msg.MSG_CANNOT_REOPEN_INVOICE_FROM_DELIVERY_NOTES());
		return false;
	}

	if (!SessionProvider.hasCommonMaster(document.PosId)) {
		await Message.show(Res.Msg.MSG_CANNOT_REOPEN_AN_INVOICE_FROM_OTHER_POS(document.PosName));
		return false;
	}

	const payments = await InvoiceFacade.getDocumentPayments(document.Id);
	const hasCardTransactions = payments.some(p => p.HasCardTransaction);
	if (hasCardTransactions) {
		await Message.show(Res.Msg.MSG_CANNOT_REOPEN_AN_INVOICE_WITH_CARD_TRANSACTION());
		return false;
	}

	if (SessionProvider.getCurrent().MasterHasCashControl && (payments.some(x => x.IsCash && x.Amount !== 0) || payments.some(x => x.ChangeAmount !== 0))) {
		await Message.show(Res.Msg.MSG_CANNOT_REOPEN_AN_INVOICE_WITH_CASH_TRANSACTION_AND_MASTER_HAS_CASH_CONTROL());
		return false;
	}

	return true;
}

export async function ensureCanRefund(document: { Id: number, Type: DocumentType }): Promise<boolean> {

	if (!SessionProvider.getCurrent().AllowCashTransactions) {
		await Message.show(Res.Msg.MSG_CURRENT_POS_DOES_NOT_ALLOW_CASH_TRANSACTIONS());
		return false;
	}

	if (document.Type !== DocumentType.BasicInvoice && document.Type !== DocumentType.StandardInvoice) {
		await Message.show(Res.Msg.MSG_INVALID_OPERATION_FOR_REFUND());
		return false;
	}

	const hasBeenRefunded = await InvoiceFacade.hasAlreadyBeenRefunded(document.Id);
	if (hasBeenRefunded) {
		await Message.show(Res.Msg.MSG_CANNOT_CREATE_REFUND_BECAUSE_THERE_IS_ALREADY_A_REFUND());
		return false;
	}

	return true;
}

export async function ensureCanConvertToStandard(document: { Id: number, Type: DocumentType }): Promise<boolean> {

	if (!SessionProvider.getCurrent().AllowCashTransactions) {
		await Message.show(Res.Msg.MSG_CURRENT_POS_DOES_NOT_ALLOW_CASH_TRANSACTIONS());
		return false;
	}

	if (document.Type !== DocumentType.BasicInvoice) {
		await Message.show(Res.Msg.MSG_INVOICE_IS_ALREADY_STANDARD());
		return false;
	}

	const hasBeenRefunded = await InvoiceFacade.hasAlreadyBeenRefunded(document.Id);
	if (hasBeenRefunded) {
		await Message.show(Res.Msg.MSG_CANNOT_CONVERT_TO_STANDARD_BECAUSE_THERE_IS_ALREADY_A_REFUND());
		return false;
	}

	return true;
}

